<template>
  <div class="layout-full-center">
    <div class="layout-full-center__form">
      <img src="@/assets/images/logo.png" alt="SDOS" width="140px" class="u-mb">
      <login-form @tryLogin="$router.push({ name: 'userIndex' })" />
    </div>
    <div class="layout-full-center__img"></div>
  </div>
</template>

<script>
import LoginForm from '@/components/forms/login-form'
export default {
  name: 'home',

  components: {
    LoginForm
  }
}
</script>
